import React, {Component} from 'react';
import {Form, notification} from 'antd';
import config from 'src/commons/config-hoc';
import {FormElement, FormItem, ModalContent, PageContent} from 'ra-lib';
import MD5 from 'crypto-js/md5';

@config({
    ajax: true,
    connect: state => ({loginUser: state.layout.loginUser}),
    modal: {
        title: '修改密码',
        width: 420,
    },
})
export default class ModifyPassword extends Component {
    state = {
        loading: false,
    };

    handleOk = (values) => {
        if (this.state.loading) return;
        const {onOk} = this.props;
        const md5newPass = MD5(values.password).toString();
        const postParams = {uid: values.uid, name: values.name, password: md5newPass, email: md5newPass};

        this.setState({loading: true});
        this.props.ajax.post('/api/user/updateUserPass', postParams)
            .then(res => {
                console.log(res);
                if (res.error == 0) {
                    notification['success']({message: '操作提示', description: res.message});
                    if (onOk) onOk();
                } else {
                    notification['error']({message: '操作提示', description: res.message});
                }
            })
            .finally(() => this.setState({loading: false}));
    };

    validatePassword = (password) => {
        const hasNumber = /\d/.test(password);
        const hasLetter = /[a-zA-Z]/.test(password);
        return hasNumber && hasLetter;
    };

    handleCancel = () => {
        const {onCancel} = this.props;
        if (onCancel) onCancel();
    };

    render() {
        const {loginUser} = this.props;
        const uid = loginUser?.uid;
        const {loading} = this.state;
        const labelWidth = 100;

        return (
            <ModalContent
                loading={loading}
                surplusSpace={false}
                onOk={() => this.form.submit()}
                onCancel={this.handleCancel}
            >
                <PageContent>
                    <Form ref={form => this.form = form} onFinish={this.handleOk} initialValues={{uid}}>
                        <FormElement type="hidden" name="uid" initialValue={uid}/>

                        <FormElement
                            label="当前用户名"
                            labelWidth={labelWidth}
                            name="name"
                            initialValue={loginUser?.name}
                            disabled={true}
                        />

                        <FormElement
                            label="新密码"
                            labelWidth={labelWidth}
                            type="password"
                            name="password"
                            maxLength={20}
                            minLength={6}
                            required
                        />
                        <FormElement
                            label="确认密码"
                            labelWidth={labelWidth}
                            type="password"
                            name="reNewPassword"
                            dependencies={['password']}
                            maxLength={20}
                            minLength={6}
                            required
                            rules={[
                                ({getFieldValue}) => ({
                                    validator(rule, value) {
                                        if ((!value || getFieldValue('password') === value) && value.length > 5) {
                                            if (/\d/.test(value) && /[a-zA-Z]/.test(value)) {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject('密码必须包括数字和字母组成！');
                                            }
                                        }
                                        return Promise.reject('新密码与确认新密码不同或长度不正确！');
                                    },
                                }),
                            ]}
                        />
                    </Form>
                </PageContent>
            </ModalContent>
        );
    }
}

